import { useCallback, useContext, useEffect } from 'react';
import { useCompanyNotes } from '@components/Note';
import { SideMenuContext } from '@/pages/CompanyReport/components/Overview/components/SideMenu/context';

import NotesSidebar from '../components/MyNotes/components/NotesSidebar';

interface Props {
  companyId?: string;
  uniqueSymbol?: string;
}

export const useCreateNotesSidebar = ({ companyId, uniqueSymbol }: Props) => {
  const { createSideMenu, currentId, setShowMenu, showMenu } =
    useContext(SideMenuContext);
  const { data: notes } = useCompanyNotes(companyId);
  const hasNotes = notes && notes.length > 0;

  const closeSidebar = useCallback(() => {
    setShowMenu('closed');
  }, [setShowMenu]);

  const openSidebar = useCallback(() => {
    setShowMenu('my-notes');
  }, [setShowMenu]);

  useEffect(() => {
    if (showMenu && currentId === 'my-notes' && !hasNotes) {
      closeSidebar();
    }
  }, [showMenu, currentId, hasNotes, closeSidebar]);

  useEffect(() => {
    if (typeof createSideMenu === 'function' && hasNotes) {
      createSideMenu(
        <NotesSidebar
          closeSidebar={closeSidebar}
          companyId={companyId}
          uniqueSymbol={uniqueSymbol}
          notes={notes}
        />,
        'my-notes'
      );
    }
  }, [notes, companyId, uniqueSymbol, hasNotes, createSideMenu, closeSidebar]);

  return {
    closeSidebar,
    openSidebar,
    isSidebarShowing: showMenu,
    shouldShowSidebar: hasNotes,
  };
};
